module.exports = __webpack_public_path__ + "img/awesome-walking.9072567f.svg";